import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import userReducer from "./userReducer";
import paymentReducer from "./paymentReducer";
import globalReducer from "./globalReducer";
import flashMessage from "./flashMessage";

const reducers = {
  form: formReducer,
  user: userReducer,
  payment: paymentReducer,
  global: globalReducer,
  flashMessage: flashMessage
};

export default combineReducers(reducers);
